import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ArReceiptDto,
  ArReceiptListDto,
  ArReceiptFilterDto,
  CreateArReceiptRequest,
  UpdateArReceiptRequest,
} from '@/types/arReceipt.types';

export const arReceiptApi = {
  /** GET /api/v1/ar-receipts — paginated list */
  getList: (filter?: ArReceiptFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ArReceiptListDto>>>('/ar-receipts', { params: filter }),

  /** GET /api/v1/ar-receipts/{id} — full receipt with lines */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ArReceiptDto>>(`/ar-receipts/${id}`),

  /** POST /api/v1/ar-receipts — create new receipt (Draft) */
  create: (data: CreateArReceiptRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/ar-receipts', data),

  /** PUT /api/v1/ar-receipts/{id} — update draft receipt */
  update: (id: string, data: UpdateArReceiptRequest) =>
    apiClient.put<ApiResponse<object>>(`/ar-receipts/${id}`, data),

  /** POST /api/v1/ar-receipts/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-receipts/${id}/submit`),

  /** POST /api/v1/ar-receipts/{id}/approve — approve the receipt */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-receipts/${id}/approve`, { remarks }),

  /** POST /api/v1/ar-receipts/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-receipts/${id}/reject`, { reason }),

  /** POST /api/v1/ar-receipts/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-receipts/${id}/post`),

  /** POST /api/v1/ar-receipts/{id}/reverse — create reversal receipt */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/ar-receipts/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/ar-receipts/{id}/cancel — cancel a draft/submitted/approved receipt */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-receipts/${id}/cancel`, { reason }),

  /** DELETE /api/v1/ar-receipts/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/ar-receipts/${id}`),
};
